import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ReasonService } from '../proxy/general/controllers/reason.service';
import { VendorService } from '@controlling/proxy/controlling/controllers/vendor.service';

FieldBuilder.setNamespace('General');

export const QUICKRESPONSECODE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('qrCode', 'Entity.QuickResponseCode.QRCode')
    .required()
    .maxLength(128)
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.QuickResponseCode.IsActive')
    .build(),
  FieldBuilder
    .foreignKey('deactivationReasonId', 'Entity.Person.DeactivationReason', ReasonService)
    .displayFromNested('deactivationReason.name')
    .sortBy('deactivationReason.name')
    .build(),
];

export const QUICKRESPONSECODE_CONFIG = {
  entityName: 'QuickResponseCode',
  localizationKey: 'General::Entity.QuickResponseCode',
  fields: QUICKRESPONSECODE_FIELDS,
  permission: 'GeneralPersons.QuickResponseCodes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Persons + MENU_NAME_SUFFIX,
};
